import React from "react";
import Modal from "../../common/modal/Modal";

const ConfirmDeleteModal = ({ open, deleting, onCancel, onConfirm }) => (
  <Modal
    open={open}
    onClose={deleting ? undefined : onCancel}
    title="Delete this catalog?"
    subtitle="It will be removed from your portfolio and no longer shown to customers."
    size="sm"
    footer={
      <>
        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onCancel} disabled={deleting}>
          Cancel
        </button>
        <button type="button" className="btn btn-danger btn-sm px-3" onClick={onConfirm} disabled={deleting}>
          {deleting ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />
              Deleting…
            </>
          ) : (
            "Delete"
          )}
        </button>
      </>
    }
  >
    <p className="mb-0 small text-secondary">This action cannot be undone.</p>
  </Modal>
);

export default ConfirmDeleteModal;
